import { useQueryClient } from '@tanstack/react-query';

const useInvalidateQueries = () => {
  const queryClient = useQueryClient();

  return async () => {
    await queryClient.invalidateQueries();
  };
};

export default useInvalidateQueries;
